import { handlePlaySound } from '@handlers/handlePlaySound'
import { handleTriggerAnimation } from '@shared'

export function handleMismatchOutcome () {
  handlePlaySound('mismatch')
  handleTriggerAnimation('mismatch')
}
